import React, {useEffect, useState} from 'react';
import TransactionDetailsAPI from "../api/TransactionDetailsAPI";
import '../utils/Style/component/transactionDetails.scss';
import UtcToLocal from "./UtcToLocal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faXmark} from "@fortawesome/free-solid-svg-icons";
import {capitalizeFirstLetters, formatAccount, formatCurrency} from "../features/ValueFormater";
import TransactionDetailsSkeleton from "./skeletons/TransactionDetailsSkeleton";
import {setActionPayload, setActionType} from "../features/authorizationSlice";
import {ACTION_TYPES} from "../app/actionTypes";
import {useDispatch} from "react-redux";
import {useOutletContext} from "react-router-dom";


function TransactionDetails({
                                activeRowIndex,
                                setActiveRowIndex,
                                visible,
                                setVisible,
                                TransactionID,
                            }) {
    const {
        GetTransactionDetails,
        UploadTransactionDetailsFile,
        transactionDetails,
        detailsLoading
    } = TransactionDetailsAPI();

    const [transactionID, setTransactionID] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileVisible, setFileVisible] = useState(false);
    const [error, setError] = useState("");

    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    useEffect(() => {
        TransactionID &&
        GetTransactionDetails(TransactionID);
    }, [TransactionID]);

    useEffect(() => {
        setTransactionID(transactionDetails?.TransactionID);
        setFileVisible(false);
    }, [transactionDetails]);


    useEffect(() => {
        if (selectedFile && sessionStorage.getItem("EntityRole") !== "VIEWER") {
            const fileSizeLimit = 2 * 1024 * 1024; // 2 MB
            if (selectedFile.size > fileSizeLimit){
                setError("File should not be larger than 2MB.");
            }else{
                setError("");

                const reader = new FileReader();
                reader.readAsDataURL(selectedFile);
                reader.onloadend = () => {
                    const base64String = reader.result;
                    const payload = {
                        ReasonFileName: selectedFile.name,
                        ReasonFile: base64String,
                        TransactionID: transactionID,
                    };
                    UploadTransactionDetailsFile(payload).finally(()=>{
                        setSelectedFile(null);
                    })
                    setFileVisible(false);
                };
            }
        }
    }, [selectedFile]);

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };

    const handleApproveDecline = (transactionId, status) => {
        const payload = {
            TransactionID: transactionId,
            Status: status,
        }

        dispatch(setActionType(ACTION_TYPES.APPROVE_TRX));
        dispatch(setActionPayload(payload));

        onOpenQrAfterGenerate();
    }

    return (
        <div className={(activeRowIndex === -1 && !visible) ? "col-12" : "col-4"}>
            {visible ?
                <div className="secondcnt">
                    <div className="close">
                        <button onClick={() => {
                            setVisible(false);
                            setActiveRowIndex(-1)
                        }}>X
                        </button>
                    </div>
                    <div className="transferDetails">



                        {detailsLoading ? (
                            <TransactionDetailsSkeleton/>
                        ) : (
                            <>
                                <img src={transactionDetails?.TransactionType?.toLowerCase().includes("suyool to suyool")?"/Images/logo/logo-circle.png" : "/Images/transfer-logo.png" } alt=""/>

                                <div className="row">
                                    <div className="row">
                                        <div className="title">{transactionDetails?.TransactionType || "Transfer"}</div>
                                    </div>
                                    <div className="row">
                                        <div className="amount">{formatCurrency(transactionDetails?.Amount)}</div>
                                    </div>
                                    <div className="row">
                                        {/*<div className="status">*/}
                                        {/*    <b className={transactionDetails.Status}>{capitalizeFirstLetters(transactionDetails.Status)}</b>*/}
                                        {/*</div>*/}
                                        <div className="status">
                                            <b className={transactionDetails?.Status}>{transactionDetails?.Status?.split(" ")[0]}</b>
                                        </div>

                                    </div>
                                    <div className="user-details">
                                        {
                                            (transactionDetails?.BeneficiaryName || transactionDetails?.RecipientName) &&
                                            <div className="user-detail">
                                                {
                                                    transactionDetails?.BeneficiaryName &&
                                                    <div
                                                        className="detAccount name">{capitalizeFirstLetters(transactionDetails.BeneficiaryName)}</div>
                                                }
                                                {
                                                    transactionDetails?.RecipientName &&
                                                    <div
                                                        className="detAccount name">{capitalizeFirstLetters(transactionDetails.RecipientName)}</div>
                                                }
                                                <div className="Accountdet">{transactionDetails?.TransactionType.toLowerCase().includes("bank transfer")? "Beneficiary Name": "Recipient"}</div>
                                            </div>
                                        }
                                        {
                                            transactionDetails?.IBAN !== undefined && (
                                                <div className="user-detail iban">
                                                    <div className="detAccount account">
                                                        {transactionDetails.IBAN}
                                                    </div>
                                                    <div className="Accountdet">IBAN Number</div>
                                                </div>
                                            )
                                        }
                                        {
                                            transactionDetails?.RecipientMobileNo !== undefined && (
                                                <div className="user-detail">
                                                    <div
                                                        className="detAccount account">{transactionDetails.RecipientMobileNo}</div>
                                                    <div className="Accountdet">Phone Number</div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    {
                                        transactionDetails?.CardHolderName &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Cardholder Name</div>
                                            <div className="col-8 detAccount">{transactionDetails.CardHolderName}</div>
                                        </div>
                                    }
                                    {
                                        transactionDetails?.MerchantName &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Merchant Name</div>
                                            <div className="col-8 detAccount">{transactionDetails.MerchantName}</div>
                                        </div>
                                    }
                                    {(transactionDetails?.IssuedBy) &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Issued By</div>
                                            <div className="col-8 detAccount">{transactionDetails.IssuedBy}</div>
                                        </div>
                                    }

                                    <div className="hr"></div>
                                    {
                                        (transactionDetails?.TransactionID && transactionDetails.TransactionType!=="Corporate Card") &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Transaction ID</div>
                                            <div className="col-8 detAccount">{transactionDetails.TransactionID}</div>
                                        </div>
                                    }
                                    {
                                        transactionDetails?.LimitPerTransaction &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Limit per Month</div>
                                            <div className="col-8 detAccount">{formatAccount(transactionDetails.LimitPerTransaction, transactionDetails.CurrencyID)}</div>
                                        </div>
                                    }
                                    {
                                        transactionDetails?.LimitPerMonth &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Limit per Transaction</div>
                                            <div className="col-8 detAccount">{formatAccount(transactionDetails.LimitPerMonth, transactionDetails.CurrencyID)}</div>
                                        </div>
                                    }
                                    {
                                        transactionDetails?.CashWithdrawals &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Cash Withdrawals</div>
                                            <div className="col-8 detAccount">{transactionDetails.CashWithdrawals}</div>
                                        </div>
                                    }
                                    {
                                        transactionDetails?.OnlinePayments &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Online Payments</div>
                                            <div className="col-8 detAccount">{transactionDetails.OnlinePayments}</div>
                                        </div>
                                    }
                                    {
                                        transactionDetails?.POSPayments &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">POS Payments</div>
                                            <div className="col-8 detAccount">{transactionDetails.POSPayments}</div>
                                        </div>
                                    }

                                    {transactionDetails?.PaymentType &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Payment Type</div>
                                            <div className="col-8 detAccount">{transactionDetails.PaymentType}</div>
                                        </div>
                                    }
                                    {transactionDetails?.Branch &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Branch</div>
                                            <div className="col-8 detAccount">{transactionDetails.Branch}</div>
                                        </div>
                                    }
                                    {transactionDetails?.Location &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Location</div>
                                            <div className="col-8 detAccount">{transactionDetails.Location}</div>
                                        </div>
                                    }
                                    {transactionDetails?.Region &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Region</div>
                                            <div className="col-8 detAccount">{transactionDetails.Region}</div>
                                        </div>
                                    }
                                    {
                                        transactionDetails?.Date &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Date</div>
                                            <div className="col-8 detAccount">
                                                <UtcToLocal utcTimestamp={transactionDetails.Date} options={options}/>
                                            </div>
                                        </div>
                                    }

                                    {
                                        transactionDetails?.ExchangeRate &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Exchange Rate</div>
                                            <div className="col-8 detAccount">{formatAccount(transactionDetails.ExchangeRate, 2)}</div>
                                        </div>
                                    }
                                    {
                                        transactionDetails?.ExchangedAmount &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Exchanged Amount</div>
                                            <div className="col-8 detAccount">{formatCurrency(transactionDetails.ExchangedAmount)}</div>
                                        </div>
                                    }

                                    {
                                        transactionDetails?.ReasonForTransfer &&
                                        <div className="row details">
                                            <div className="col-4 Accountdet">Reason</div>
                                            <div
                                                className="col-8 detAccount">{transactionDetails.ReasonForTransfer}</div>
                                        </div>
                                    }

                                    <div>
                                        {(transactionDetails?.FileName !== undefined && !(transactionDetails.FileName === "" && !transactionDetails?.ShowAddFileButton)) && <>
                                            {(transactionDetails?.FileName) ? (
                                                !fileVisible ?
                                                    <div className="row details">
                                                        <div className="col-4 Accountdet">File</div>
                                                        <div className="col-5 detAccount">
                                                            <a className="clickable-file"
                                                               href={transactionDetails.FileUrl}>
                                                                {transactionDetails.FileName}
                                                            </a>
                                                        </div>
                                                        {
                                                            transactionDetails?.ShowAddFileButton &&
                                                            <div className="col-2">
                                                                <button className="replace-btn"
                                                                        onClick={() => setFileVisible(true)}>Replace
                                                                </button>
                                                            </div>
                                                        }
                                                    </div> : <div className="row details">
                                                        <div className="col-4 Accountdet">File</div>
                                                        <div className="col-4">
                                                            <input
                                                                placeholder="replace"
                                                                type="file"
                                                                id="myFile"
                                                                name="ReasonFile"
                                                                onClick={() => {
                                                                    setError("");
                                                                }}
                                                                onChange={
                                                                    (e) => {
                                                                        setSelectedFile(e.target.files[0])
                                                                    }
                                                                }/>
                                                            {error && (
                                                                <span className="error m-0">{error}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                            ) : (
                                                <>
                                                    {
                                                        transactionDetails?.ShowAddFileButton ? (
                                                            <div className="row details">
                                                                <div className="col-4 Accountdet">File</div>
                                                                {
                                                                    !fileVisible ? (
                                                                        <div className="col-8 detAccount">
                                                                            <button className="clickable-file-details"
                                                                                    onClick={() => setFileVisible(true)}>
                                                                                Upload
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <div className="col-4">
                                                                                <input
                                                                                    placeholder="replace"
                                                                                    type="file"
                                                                                    id="myFile"
                                                                                    name="ReasonFile"
                                                                                    onClick={() => {
                                                                                        setError("");
                                                                                        setSelectedFile(null);
                                                                                    }}
                                                                                    onChange={
                                                                                        (e) => {
                                                                                            setSelectedFile(e.target.files[0])
                                                                                        }
                                                                                    }/>
                                                                                {error && (
                                                                                    <span className="error m-0">{error}</span>
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                        ) : (
                                                            <></>
                                                        )
                                                    }
                                                </>
                                            )}
                                        </>
                                        }
                                    </div>

                                    {
                                        transactionDetails?.TransactionType !== "End of Day Closing" &&
                                        <>
                                            <div className="hr"></div>
                                            {
                                                (transactionDetails?.InitiatorName) &&
                                                <div className="row details">
                                                    <div className="col-4 Accountdet">Issued By</div>
                                                    <div
                                                        className="col-8 detAccount">{transactionDetails.InitiatorName}</div>
                                                </div>
                                            }
                                            {transactionDetails?.Client &&
                                                <div className="row details">
                                                    <div className="col-4 Accountdet">Client</div>
                                                    <div className="col-8 detAccount">{transactionDetails.Client}</div>
                                                </div>
                                            }
                                            {
                                                transactionDetails?.Type &&
                                                <div className="row details">
                                                    <div className="col-4 Accountdet">Exchange Type</div>
                                                    <div className="col-8 detAccount">{transactionDetails.Type}</div>
                                                </div>
                                            }
                                            {
                                                transactionDetails?.Updated &&
                                                <div className="row details">
                                                    <div className="col-4 Accountdet">Updated</div>
                                                    <div className="col-8 detAccount">
                                                        <UtcToLocal utcTimestamp={transactionDetails.Updated}
                                                                    options={options}/>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                transactionDetails?.StatusDescription &&
                                                <div className="row details">
                                                    <div className="col-4 Accountdet">Status</div>
                                                    <div
                                                        className="col-8 detAccount">{capitalizeFirstLetters(transactionDetails.StatusDescription)}</div>
                                                </div>
                                            }


                                        </>
                                    }


                                </div>

                                {(transactionDetails?.Status?.toLowerCase()?.includes("pending") && transactionDetails?.ShowApproveButton )&&
                                    <div className="row">
                                        <div className="col-4 Accountdet"></div>
                                        <div className="col-8 detAccount">
                                            <div className="yesNo">
                                                <button
                                                    className="yes"
                                                    onClick={() => {
                                                        setVisible(false);
                                                        setActiveRowIndex(-1);
                                                        handleApproveDecline(transactionDetails?.TransactionID, "Approve");
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faCheck}/>
                                                </button>
                                                <button
                                                    className="no"
                                                    onClick={() => {
                                                        setVisible(false);
                                                        setActiveRowIndex(-1);
                                                        handleApproveDecline(transactionDetails?.TransactionID, "Reject");
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faXmark}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                        )
                        }
                    </div>
                </div>
                :
                <></>
            }
        </div>
    );
}

export default TransactionDetails;